import { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { TextField } from '@mui/material';
import { useCreateFreePostMutation } from '../../../queries';
import FullHeightContainer from '../../common/FullHeightContainer';
import TopHeaderBar from './TopHeaderBar';
import BottomFixedBtn from '../../common/BottomFixedBtn';

interface FreeBoardProps {
  type: number;
  setWriteModalOpen: (open: boolean) => void;
  onClose?: () => void;
}

export default function FreeBoard({ type, setWriteModalOpen, onClose }: FreeBoardProps) {
  const navigate = useNavigate();
  const [registorDisabled, setRegistorDisabled] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  const { mutate: createFreePost } = useCreateFreePostMutation();

  useEffect(() => {
    setRegistorDisabled(content.length < 1 || title.length < 1);
  }, [content, title]);

  const handleCreateFreePost = useCallback(() => {
    const apiParams = {
      title,
      content,
      isPinned: false,
      output: true,
    };
    createFreePost(apiParams, {
      onSuccess: () => {
        if (onClose) {
          onClose();
        } else {
          navigate(-1);
        }
      },
      onError: (error) => {
        console.error('Error creating QnA:', error);
        toast.error('Failed to create QnA');
      },
    });
  }, [title, content, navigate, onClose, createFreePost]);

  return (
    <FullHeightContainer>
      <TopHeaderBar
        type={type}
        setWriteModalOpen={setWriteModalOpen}
        registorDisabled={registorDisabled}
        onSubmit={handleCreateFreePost}
        onClose={onClose}
      />
      <div className="pageInner">
        <div className="w-full mt-[30px]">
          <div className="font-[400] mb-[12px] text-[14px] text-[#1C1C1C] text-left">제목</div>
          <div className="w-full relative mb-[12px]">
            <TextField
              placeholder="제목을 작성해 주세요"
              variant="standard"
              fullWidth
              multiline
              value={title}
              onChange={(e) => {
                if (e.target.value.length < 51) {
                  setTitle(e.target.value);
                }
              }}
              sx={{ mb: 2 }}
            />
            <div className="absolute right-2 bottom-5 text-[12px] text-[#767676]">
              {title.length}/50
            </div>
          </div>
        </div>
        <div className="w-full mt-[30px]">
          <div className="font-[400] mb-[12px] text-[14px] text-[#1C1C1C] text-left">내용</div>
          <div className="w-full relative mb-[12px]">
            <TextField
              placeholder="문의 내용을 작성해 주세요"
              variant="outlined"
              fullWidth
              multiline
              rows={10}
              value={content}
              onChange={(e) => {
                if (e.target.value.length < 301) {
                  setContent(e.target.value);
                }
              }}
              sx={{ mb: 2 }}
            />
            <div className="absolute right-2 bottom-5 text-[12px] text-[#767676]">
              {content.length}/300
            </div>
          </div>
        </div>
      </div>
      <BottomFixedBtn title="등록" onClick={handleCreateFreePost} disabled={registorDisabled} />
    </FullHeightContainer>
  );
}
